import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  flex-direction: column;
  padding: 23% 24px 0;

  position: relative;
  // min-height: 100vh;

  min-height: 100dvh;
  min-height: 100svh;
  max-height: 100vh;

  display: flex;
  width: 100%;
`;

export const ContainerAvatar = styled.div(
  ({ color, large }: { color: string; large: boolean }) => css`
    color: ${color || 'rgba(255,255,255,0.25)'};
    margin: clamp(26px, 7vmin, 50px) auto 0;

    height: clamp(281px, 76vw, 335px);
    width: clamp(255px, 68vw, 285px);

    position: relative;

    ${large &&
    css`
      @media (min-width: 360px) {
        width: clamp(264px, 82.5vw, 355px);
        height: clamp(240px, 92vw, 395px);

        > div:nth-child(2) {
          top: calc(clamp(240px, 92vw, 395px) / 10 * 0.9);
        }
      }

      > div:nth-child(2) {
        margin-left: 8px;
        margin-top: 5px;

        @media (max-width: 359px) {
          margin-left: 0;
          margin-top: 0;
        }
      }

      margin-top: clamp(52px, 14vmin, 100px);
      position: absolute;

      right: 0;
      left: 0;
    `}

    > svg {
      transform: translate(-50%, -50%);
      position: absolute;

      height: auto;
      width: 100%;

      z-index: 1;
      left: 50%;
      top: 50%;
    }

    > aside:last-child {
      position: absolute;
    }
  `
);

export const Control = styled.div`
  width: calc(100% - 48px);
  position: absolute;
  max-height: 313px;
  margin-top: auto;
  bottom: 8.62vh;
  z-index: 2;
`;

export const ControlAside = styled.div`
  text-align: center;
  position: absolute;
  bottom: -3.6946vh;

  width: 77.333vw;
  margin: 0 auto;

  right: 0;
  left: 0;

  > h2 {
    font-family: ${Theme.font.family.speedeeCondensed};

    font-size: ${Theme.rems(40)};
    color: ${Theme.color.white};
    text-transform: uppercase;

    margin-bottom: 8px;
    line-height: 90%;
  }

  > span {
    color: ${Theme.color.white};
    margin-bottom: 16px;
    line-height: 140%;
  }

  > button {
    border-color: ${Theme.color.white};
    margin: 0 auto;
    width: 208px;

    &:nth-child(3) {
      margin-top: 16px;
      margin-bottom: 10px;
    }

    &:last-child {
      background-color: transparent;
      color: ${Theme.color.white};

      line-height: 240%;
      box-shadow: none;
    }
  }
`;

export const WrapperIconRotate = styled.div`
  top: calc(clamp(281px, 76vw, 335px) / 10 * 0.9);
  position: absolute;

  height: 40px;
  width: 40px;

  left: 20px;
  z-index: 1;

  svg {
    height: 40px;
    width: 40px;
  }
`;